'use strict';

const _ = require('underscore');
const Base = require('components/Base/Base');
const CountUp = require('countup.js');
const Events = require('constants/Events');

require('./IndexResults.less');

const IndexResultsCard = require('components/IndexResultsCard/IndexResultsCard');

const Selectors = {
    el: '.IndexResults',
    cardsCount: '.IndexResults-cardsCount',
    title: '.IndexResults-title',
    bestPlaceTitle: '.IndexResults-bestPlaceTitle',
    tailored: '.IndexTailored',
    tailoredSequenceWrapper: '.IndexTailored-sequenceWrapper',
    resultsCardInner: '.IndexResults-card[data-tp="placeholder"] .IndexResults-card-inner',
    resultsCardInnerContainer: '.IndexResults-card-inner-container',
    resultsCardInnerContainerBlock: '.IndexResults-card-inner-container-block',
    lastVideo: '.IndexTailored-video_3',
    lastItem: '.IndexTailored-item:last-child',
    indexResultsCard: '.IndexResultsCard'
};

const BindFunctions = [
    'attachEvents',
    'processCardsNumbers',
    'animateCount',
    'activateSectionShown',
    'onScroll',
    'onResize'
];

const CardsSettings = {
    aspect: 407.0 / 630.0,
    xcountDesk: 1920.0 / 407.0,
    xshiftDesk: -57.0 / 407.0,
    ycountDesk: 4.8,
    xcountMob: 640.0 / 298.0,
    xshiftMob: -128.0 / 298.0,
    ycountMob: 2.3
};

const CountOfCounterIterations = 8;

module.exports = Base.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);
        _.bindAll(this, BindFunctions);

        setTimeout(() => {
            this.indexResultsCard = new IndexResultsCard({
                $el: this.$(Selectors.indexResultsCard)
            });

            this.$cardsCount = this.$(Selectors.cardsCount);
            this.$(Selectors.title).css('opacity', 0);
            this.titleObj = {
                $container: this.$(Selectors.title),
                className: 'IndexResults-titleWord'
            };
            this.$(Selectors.bestPlaceTitle).css('opacity', 0);
            this.bestPlaceTitleObj = {
                $container: this.$(Selectors.bestPlaceTitle),
                className: 'IndexResults-bestPlaceWord'
            };
            app.utils.splitLineToWords(this.titleObj);
            app.utils.splitLineToWords(this.bestPlaceTitleObj);
            this.processCardsNumbers();

            if (!app.settings.isIE) {
                this.initCards();
                this.attachEvents();
                this.onResize();
            }
        }, 1500);

        // app.vent.on(Events.common.pageLoaded, function () {
        //     $('body').removeClass('isInitialState');
        //     $(window).scrollTop(5991);
        // });
    },

    attachEvents: function () {
        app.vent.on(Events.common.scroll, this.onScroll);
        app.vent.on(Events.common.resize, this.onResize);
        app.vent.on(Events.home.hero.sequenceEnded, this.onResize);
    },

    activateSectionShown: function ($el) {
        if ($el.is(this.$(Selectors.title))) {
            this.$(Selectors.title).css('opacity', 1);
            this.animateTitleTimeline = app.utils.animateTextByLines(this.titleObj, {
                lineDuration: 1000,
                lineDelay: 30,
                shift: 30
            });
        }

        if ($el.is(this.$(Selectors.bestPlaceTitle))) {
            this.$(Selectors.bestPlaceTitle).css('opacity', 1);
            this.animateBestPlaceTimeline = app.utils.animateTextByLines(this.bestPlaceTitleObj, {
                lineDuration: 1000,
                lineDelay: 30,
                shift: 30
            });
        }

        if ($el.is(this.$cardsCount)) {
            this.animateCount();
        }
    },

    processCardsNumbers: function () {
        const cardText = this.$cardsCount.text();
        const sign = this.getSign(cardText);
        this.firstNumber = this.getFirstNumber(cardText);
        const newFirstNumber = this.firstNumber - CountOfCounterIterations;
        const lastNumbers = this.getLastNumbers(cardText, sign);
        const signSpan = document.createElement('span');
        signSpan.textContent = sign;
        const firstNumberSpan = document.createElement('span');
        firstNumberSpan.textContent = newFirstNumber;

        this.$cardsCount.empty();
        this.$cardsCount.append(firstNumberSpan);
        lastNumbers.forEach((number) => {
            const numberSpan = document.createElement('span');
            numberSpan.textContent = '.' + number;
            this.$cardsCount.append(numberSpan);
        });

        this.$cardsCount.append(signSpan);
    },

    getSign: function (cardText) {
        return cardText[cardText.length - 1];
    },

    getLastNumbers: function (cardText, sign) {
        const numbers = cardText.split('.');

        numbers.shift();
        const lastNumberWithoutSign = numbers[numbers.length - 1].replace(sign, '');
        const numbersWithoutSign = [...numbers.slice(0, numbers.length - 1), lastNumberWithoutSign];

        return numbersWithoutSign;
    },

    getFirstNumber: function (cardText) {
        const numbers = cardText.split('.');

        return +numbers[0];
    },

    animateCount: function () {
        const $countOfCards = this.$cardsCount.find('span').first();

        new CountUp.CountUp($countOfCards[0], this.firstNumber, {
            startVal: this.firstNumber - CountOfCounterIterations,
            duration: 2
        }).start();
    },

    initCards: function () {
        this.cards = {};
        this.cards.canvas = this.$('.IndexResults-canvas canvas')[0];
        this.cards.gl = this.cards.canvas.getContext('webgl') || this.cards.canvas.getContext('experimental-webgl');

        const gl = this.cards.gl;
        const program = gl.createProgram();

        const Uniform = function (name, suffix) {
            this.name = name;
            this.suffix = suffix;
            this.location = gl.getUniformLocation(program, name);
        };

        Uniform.prototype.set = function (...values) {
            const method = 'uniform' + this.suffix;
            const args = [this.location].concat(values);
            gl[method].apply(gl, args);
        };


        const Rect = function (gl) {
            const buffer = gl.createBuffer();
            gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
            gl.bufferData(gl.ARRAY_BUFFER, Rect.verts, gl.STATIC_DRAW);
        };

        Rect.verts = new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]);

        Rect.prototype.render = function (gl) {
            gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        };


        const addShader = function (source, type) {
            const shader = gl.createShader(type);
            gl.shaderSource(shader, source);
            gl.compileShader(shader);
            const isCompiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
            if (!isCompiled) {
                throw new Error('Shader compile error: ' + gl.getShaderInfoLog(shader));
            }
            gl.attachShader(program, shader);
        };


        addShader($('#IndexResults-cards-vs').text(), gl.VERTEX_SHADER);
        addShader($('#IndexResults-cards-fs').text(), gl.FRAGMENT_SHADER);

        // link & use program
        gl.linkProgram(program);
        gl.useProgram(program);

        // create fragment uniforms
        this.cards.uScrollSkew = new Uniform('uScrollSkew', '1f');
        this.cards.uYScaler = new Uniform('uYScaler', '1f');
        this.cards.uAnti = new Uniform('uAnti', '1f');
        this.cards.uWidth = new Uniform('uWidth', '1f');
        this.cards.uHeight = new Uniform('uHeight', '1f');
        this.cards.uXCount = new Uniform('uXCount', '1f');
        this.cards.uXShift = new Uniform('uXShift', '1f');
        this.cards.uOneMore = new Uniform('uOneMore', '1f');

        // create position attrib
        this.cards.billboard = new Rect(gl);
        const positionLocation = gl.getAttribLocation(program, 'a_position');
        gl.enableVertexAttribArray(positionLocation);
        gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);
    },

    onScrollField: function (force) {
        const scrollEnd = this.cards.elTop + this.cards.canvasHeight;
        const scrollStart = scrollEnd - this.cards.canvasHeight * 1 / 3;
        const scrollTop = window.pageYOffset + this.windowHeight - scrollStart;
        const scrollPercentage = scrollTop / (scrollEnd - scrollStart);
        const self = this;


        const renderCurrent = function () {
            self.cards.uScrollSkew.set(self.cards.xcount * Math.min(Math.max(scrollPercentage, 0), 0.92));
            self.cards.billboard.render(self.cards.gl);
        };

        if (force || (scrollPercentage >= 0 && scrollPercentage <= 0.92)) {
            renderCurrent();
            this.isOutsideRendered = false;
        } else {
            if (!this.isOutsideRendered) {
                renderCurrent();
            }
            this.isOutsideRendered = true;
        }
    },

    onScroll: function () {
        this.onScrollField(false);
    },

    onResize: function () {
        this.isMobile = window.matchMedia('(max-width: 767px)').matches;

        if (!this.isMobile) {
            //separate card calculations
            const scrollTop = window.pageYOffset;

            const $placeholder = $(Selectors.resultsCardInner);
            const placeholderBB = $placeholder[0].getBoundingClientRect();
            const placeholderWidth = placeholderBB.width;
            const placeholderHeight = placeholderBB.height;
            const placeholderLeft = placeholderBB.left;
            const placeholderTop = placeholderBB.top + scrollTop;

            const $tailored = $(Selectors.tailored);
            const tailoredBB = $tailored[0].getBoundingClientRect();
            // const tailoredWidth = tailoredBB.width;
            const tailoredHeight = tailoredBB.height;
            // const tailoredLeft = tailoredBB.left;
            const tailoredTop = tailoredBB.top + scrollTop;

            const lastItemHeight = $(Selectors.lastItem)[0].getBoundingClientRect().height;

            const $sequence = $(Selectors.tailoredSequenceWrapper);
            const sequenceBB = $sequence[0].getBoundingClientRect();
            // const sequenceWidth = sequenceBB.width;
            const sequenceHeight = sequenceBB.height;
            // const sequenceLeft = sequenceBB.left;
            // const sequenceTop = sequenceBB.top + scrollTop;

            const $lastVideo = $(Selectors.lastVideo);
            const lastVideoBB = $lastVideo[0].getBoundingClientRect();
            const lastVideoWidth = lastVideoBB.width;
            const lastVideoHeight = lastVideoBB.height;
            const lastVideoLeft = lastVideoBB.left;
            // const lastVideoTop = lastVideoBB.top + scrollTop;

            const cardContainerHeight = (placeholderTop + placeholderHeight) -
                (tailoredTop + tailoredHeight - sequenceHeight * 2);

            $(Selectors.resultsCardInnerContainer).css({
                'height': cardContainerHeight + 100
            });

            $(Selectors.resultsCardInnerContainerBlock).css({
                'width': lastVideoWidth,
                'height': lastVideoHeight,
                'margin-left': lastVideoLeft - placeholderLeft,
                'top': $lastVideo.position().top
            });

            app.vent.trigger(Events.home.results.cardResize, {
                width: lastVideoWidth,
                height: lastVideoHeight,
                lastVideoLeft: lastVideoLeft,
                placeholderLeft: placeholderLeft,
                placeholderWidth: placeholderWidth,
                placeholderHeight: placeholderHeight,
                cardContainerHeight: cardContainerHeight,
                scrollVisibleStart: tailoredTop + tailoredHeight - sequenceHeight - lastItemHeight * 2,
                scrollStart: tailoredTop + tailoredHeight - sequenceHeight,
                scrollRange: cardContainerHeight - lastVideoHeight - sequenceHeight
            });
        }


        //cards field calculations
        this.windowHeight = document.documentElement.clientHeight;
        this.windowWidth = document.documentElement.clientWidth;

        if (window.matchMedia('(min-width: 768px)').matches) {
            this.cards.xcount = CardsSettings.xcountDesk;
            this.cards.xshift = CardsSettings.xshiftDesk;
            this.cards.ycount = CardsSettings.ycountDesk;
            this.cards.onemore = 1;
        } else {
            this.cards.xcount = CardsSettings.xcountMob;
            this.cards.xshift = CardsSettings.xshiftMob;
            this.cards.ycount = CardsSettings.ycountMob;
            this.cards.onemore = 0;
        }

        const pixelRatio = window.devicePixelRatio;
        const canvasWidth = this.cards.canvas.offsetWidth;
        const cardHeight = canvasWidth / this.cards.xcount / CardsSettings.aspect;
        this.cards.canvasHeight = Math.round(cardHeight * this.cards.ycount);
        this.cards.canvas.style.height = this.cards.canvasHeight + 'px';
        this.cards.canvas.setAttribute('width', canvasWidth * pixelRatio);
        this.cards.canvas.setAttribute('height', this.cards.canvasHeight * pixelRatio);
        this.cards.elTop = $(this.cards.canvas).offset().top;

        this.cards.uAnti.set((this.cards.xcount / canvasWidth) / pixelRatio);
        this.cards.uYScaler.set(this.cards.canvasHeight / cardHeight);
        this.cards.uWidth.set(canvasWidth * pixelRatio);
        this.cards.uHeight.set(this.cards.canvasHeight * pixelRatio);
        this.cards.gl.viewport(0, 0, canvasWidth * pixelRatio, this.cards.canvasHeight * pixelRatio);

        this.cards.uXCount.set(this.cards.xcount);
        this.cards.uXShift.set(this.cards.xshift);
        this.cards.uOneMore.set(this.cards.onemore);

        this.onScrollField(true);
    }
});
